export default __webpack_public_path__ + "static/esop-0bfbd8db9ef0fcb9bee85c8a0a609748.png";